module.exports = __webpack_public_path__ + "static/media/female-pic.9e452610.jpg";